fx.ns("shared.stage.components", class CalendarGridSimple extends shared.stage.components.BaseCalendarGrid {
    constructor(component, model, parent, manual, commands) {
        super(component, model, parent, commands);

        //this.cellClass = shared.stage.BaseCalendarCell;

        this.dayNames = [fx.text("L"),
        fx.text("M"),
        fx.text("M"),
        fx.text("J"),
        fx.text("V"),
        fx.text("S"),
        fx.text("D")];
    }

    /**
     * Component initialization.
     */
    create() {
        super.create();

        this.monthTitle.viewport({ top: 93 * this.model.creation.extraScale, right: 17 * this.model.creation.extraScale });
        this.monthTitle.css({ fontSize: 16 * this.model.creation.extraScale + "px" });
        this.yearTitle.viewport({ top: 110 * this.model.creation.extraScale, right: 17 * this.model.creation.extraScale });
        this.yearTitle.css({ fontSize: 6 * this.model.creation.extraScale + "px" });
        this.monthNumberTitle.viewport({ top: 15 * this.model.creation.extraScale, left: 15 * this.model.creation.extraScale });
        this.monthNumberTitle.css({ fontSize: 34 * this.model.creation.extraScale + "px" });
        this.titleContainer.viewport({ top: this.model.creation.isSinglePage ? 5 * this.model.creation.extraScale : 25 * this.model.creation.extraScale, height: 120 * this.model.creation.extraScale, width: "100%" });
    }

    positionGrid() {
        this.css({
            width: this.model.creation.pageWidth / 2,
            height: this.model.creation.pageHeight,
            transform: "translate(" + (this.model.creation.pageWidth / 2) + "px," + 0 + "px)"
        });

        this.container.top(0);
    }

});